
import dateFormat from 'vux/src/tools/date/format.js'

export default {
name: '',
components: { dateFormat },
data () {
return {
$vue: '',
newsId: this.$route.params.newsId,
title: '',
content: '',
keyWord: '',
releasedDt: ''
}
},
beforeMount () {
this.$vue = this
this.getNewsDetail()
},
methods: {

async getNewsDetail () {
let params = new URLSearchParams()
params.append('newsId', this.newsId)
let suc = await this.$http.post(this.$vue.getData('NEWS_DETAIL_URL'), params)
if (suc.data.result === '1') {
this.title = suc.data.data.NEWS_TITLE
this.content = suc.data.data.NEWS_CONTENT
this.keyWord = suc.data.data.NEWS_KEYWORD
this.releasedDt = dateFormat(suc.data.data.RELEASED_DT.time, 'YYYY-MM-DD HH:mm:ss')

window.document.title = this.title
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/base/news/news.vue